
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","height":"48","viewBox":"0 -960 960 960","width":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M378-248.391q-7.696 0-14.674-2.848t-13.109-8.978l-181-181Q157.391-453.043 157.391-470t11.826-28.783q11.826-11.826 28.066-11.826 16.239 0 28.63 11.826L378-346.696l355.652-355.087q11.826-11.826 28.283-12.109 16.456-.282 28.283 12.109 11.826 11.826 11.826 28.566 0 16.739-11.826 28.565L405.783-260.217q-6.131 6.13-13.109 8.978T378-248.391z"}})])
          )
        }
      }
    